<template>
  <div class="sidebar" :data="backgroundColor">
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <!-- brand row; a layout can replace it (the console puts the location switcher here) -->
      <slot name="brand">
        <div class="logo">
          <span class="simple-text logo-mini">
            <img v-if="logo" v-twin-src="logo" alt="app-logo" />
          </span>
          <span class="simple-text logo-normal">
            {{ title }}
          </span>
        </div>
      </slot>
      <slot></slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
    <slot name="footer"></slot>
    <!-- collapse toggle on the sidebar's right edge; outside the scroll area so it is not clipped -->
    <button
      type="button"
      class="sidebar-collapse-btn"
      :title="collapseLabel"
      :aria-label="collapseLabel"
      @click="minimizeSidebar"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 7-5 5 5 5" /></svg>
    </button>
  </div>
</template>
<script>
export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'Game Master',
      description: 'Sidebar title'
    },
    shortTitle: {
      type: String,
      default: 'GM',
      description: 'Sidebar short title'
    },
    logo: {
      type: String,
      default: 'img/otc-logo.png',
      description: 'Sidebar app logo'
    },
    backgroundColor: {
      type: String,
      default: 'vue',
      validator: value => {
        let acceptedValues = [
          '',
          'vue',
          'blue',
          'green',
          'orange',
          'red',
          'primary',
          'brand'
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        'Sidebar background color (vue|blue|green|orange|red|primary|brand)'
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these."
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  computed: {
    collapseLabel() {
      if (this.$sidebar && this.$sidebar.showSidebar) return 'Close menu';
      return this.$sidebar && this.$sidebar.isMinimized ? 'Expand sidebar' : 'Collapse sidebar';
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    // Desktop: fold or unfold. Below 1200px (the drawer) the same tab closes the drawer.
    minimizeSidebar() {
      if (!this.$sidebar) return;
      if (window.innerWidth < 1200) {
        this.$sidebar.displaySidebar(false);
        return;
      }
      this.$sidebar.toggleMinimize();
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
